import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import ChannelConnectionsAdminService from "services/admin/channelConnections";
import { CONNECTION_STATUS } from "../Whatsapp/WhatsappConnect";

// Удалять можно только неподключённый канал: у подключённого осталась бы живая сессия/вебхук
export const canDeleteChannel = (connection: any) =>
  !!connection && connection.connectionStatus !== CONNECTION_STATUS.CONNECTED;

/**
 * Удаление канала с подтверждением.
 * Возвращает true, если канал удалён.
 */
export const useDeleteChannel = () => {
  const queryClient = useQueryClient();

  return async (connection: any): Promise<boolean> => {
    if (!canDeleteChannel(connection)) return false;
    if (
      !window.confirm(
        "Удалить канал? Автоматизации и агент на этом канале перестанут работать.",
      )
    ) {
      return false;
    }
    try {
      await ChannelConnectionsAdminService.delete(connection.id);
      await queryClient.invalidateQueries({ queryKey: ["channel-connections"] });
      toast.success("Канал удалён");
      return true;
    } catch (error: any) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Не удалось удалить канал");
      return false;
    }
  };
};
